import React, {useEffect} from 'react';
import {Link, Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
import Storage from "../../utils/storage";


export function withRouter(Component) {
    return function ComponentWithRouterProp(props) {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();

        return (
            <Component
                {...props}
                location={location}
                navigate={navigate}
                params={params}
            />
        );
    };
}

export function ScrollToTop() {
    const {pathname} = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, [pathname]);

    return null;
}

class AdminLayout extends React.Component {
    constructor(props) {
        super(props);

        this.myRef = React.createRef();

        this.renderNavigation = this.renderNavigation.bind(this);
        this.logout = this.logout.bind(this);
    }

    componentDidMount() {

    }

    logout() {
        this.props.cookies.remove('token', {path: '/'});
        Storage.delete('token');
        this.props.navigate('/admin/login/');
    }

    renderNavigation(callback) {
        const {pathname} = this.props.location;

        const isActive = (path) => {
            return pathname === path || pathname.startsWith(path);
        };

        const getClass = (path) =>
            `button item action_16_24 ${isActive(path) ? "active" : ""}`;

        return (
            <div className="navigation">
                <Link className={getClass("/admin/panel/services")} to="/admin/panel/services/"
                      onClick={callback}>
                    Услуги
                </Link>

                <Link className={getClass("/admin/panel/employees")} to="/admin/panel/employees/"
                      onClick={callback}>
                    Сотрудники
                </Link>

                <Link className={getClass("/admin/panel/vacancies")} to="/admin/panel/vacancies/"
                      onClick={callback}>
                    Вакансии
                </Link>

                <Link className={getClass("/admin/panel/faq")} to="/admin/panel/faq/"
                      onClick={callback}>
                    Частые вопросы
                </Link>

                <Link className={getClass("/admin/panel/articles")} to="/admin/panel/articles/"
                      onClick={callback}>
                    Статьи
                </Link>

                <Link className={getClass("/admin/panel/docs")} to="/admin/panel/docs/"
                      onClick={callback}>
                    Документы
                </Link>

                <Link className={getClass("/admin/panel/empdocs")} to="/admin/panel/empdocs/"
                      onClick={callback}>
                    Документы врачей
                </Link>

                <Link className={getClass("/admin/panel/banner/")} to="/admin/panel/banner/"
                      onClick={callback}>
                    Баннер на главной
                </Link>

                <Link className={getClass("/admin/panel/users/")} to="/admin/panel/users/"
                      onClick={callback}>
                    Вход в панель администратора
                </Link>
            </div>
        );
    }

    render() {
        return <div className='root-admin'>
            <div className='admin-container'>
                <div className='navigation-virtual'/>
                <div className='navigation'>
                    <div className='top'>
                        <div className='title'>
                            Панель администратора ЭСТЭЙ
                        </div>
                        <div className='buttons'>
                            <a className='button site' href='/' target='_blank'>
                                Перейти на сайт
                            </a>
                            <div className='button logout' onClick={this.logout}>
                                Выйти
                            </div>
                        </div>
                    </div>
                    {this.renderNavigation()}
                </div>
                <div className='admin-content-container'>
                    <Outlet/>
                </div>
            </div>
        </div>
    }
}


export default withRouter(AdminLayout);
